<template>
  <div class="page">
    <VerticalMenuTemplate :sidebar-menu="sidebarMenu" :title="title"/>
    <div class="page-content">
      <div class="page-header">
        <BreadcrumbElement :breadcrumbs="breadcrumbs"/>
      </div>

      <router-view/>

    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue';
import {BreadcrumbElement} from '@shared/components/elements';
import {VerticalMenuTemplate} from '@shared/components/templates';
import {CommonNs, type SidebarNs} from '@shared/types';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {mapStores} from "pinia";
import {useUserStore} from "@shared/stores/user.store";

export default defineComponent({
  name: 'SidebarLayout',
  components: {
    BreadcrumbElement,
    VerticalMenuTemplate,
  },
  computed: {
    ...mapStores(useWorkspaceStore, useUserStore),
  },
  data() {
    return {
      breadcrumbs: [] as CommonNs.Breadcrumb[],
      title: '',
      sidebarMenu: [] as SidebarNs.SidebarMenu[],
    };
  },
  methods: {
    createBreadcrumb(): void {
      this.breadcrumbs = [];
      this.$route.matched.forEach((path) => {
        if (path.meta.breadcrumb) {
          this.breadcrumbs.push({
            text: path.meta.breadcrumb,
            to: path.name
          } as CommonNs.Breadcrumb);
        }
      });

      if (this.breadcrumbs[0]) {
        this.title = this.breadcrumbs[0].text;
      }
    },
    createMenu(): void {
      if (this.$route.meta.data && (this.$route.meta.data as SidebarNs.SidebarContent).menu) {
        let menu = (this.$route.meta.data as SidebarNs.SidebarContent).menu;
        const wsRole = this.workspaceStore.getWorkspaceRole;
        const wsProduct = this.workspaceStore.getProduct;
        if (wsRole) {
          menu = menu.filter((m) => !m.userRole || (m.userRole && m.userRole.includes(wsRole)));
        }

        menu.forEach((m) => {
          m.menuItems = m.menuItems.filter((mi) => !mi.provider || (mi.provider === this.userStore.getUserInfo.authProvider));
        });

        this.sidebarMenu = menu.map((m) => ({
          ...m,
          menuItems: m.menuItems.filter((item) =>
              (!item.userRole || (item.userRole && item.userRole.includes(wsRole))) &&
              (!item.product || (item.product && item.product.includes(wsProduct)))
          )
              .map((item) => ({
                ...item,
                isActive: this.isActive(item.name),
              })),
        }));
      }
    },
    isActive(name: string): boolean {
      if (this.$route.meta.activeMenu) {
        return name === this.$route.meta.activeMenu;
      } else {
        return name === this.$route.name;
      }
    },
  },
  mounted(): void {
    this.createMenu();
    this.createBreadcrumb();
  },
  watch: {
    $route(to, from) {
      this.createMenu();
      this.createBreadcrumb();
    },
  },
});
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: row;

  & .page-content {
    width: calc(100% - 300px);
    box-shadow: var(--shadow-lg);
    position: absolute;
    left: 300px;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index: 9;
  }
}
</style>
